import React, { forwardRef } from 'react';
import DoorPreviewGLB from './DoorPreviewGLB.tsx';
import PreviewFailure from './PreviewFailure';

class PreviewBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error: error.message || '3D initialization failed.' };
  }

  componentDidCatch(error) {
    console.error('Configurator 3D preview failed:', error);
  }

  render() {
    return this.state.error
      ? <PreviewFailure error={this.state.error} onRetry={() => this.setState({ error: null })} />
      : this.props.children;
  }
}

// An unavailable graphics context or a scene initialization error must not
// unmount the configuration form, pricing, or the customer's current choices.
const ConfiguratorPreview = forwardRef((props, ref) => {
  return <PreviewBoundary>
    <DoorPreviewGLB {...props} ref={ref} />
  </PreviewBoundary>;
});

ConfiguratorPreview.displayName = 'ConfiguratorPreview';
export default ConfiguratorPreview;
